import './styles.scss'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Badge } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { apiPools } from 'api'
import { fetchLists } from '../../redux/actions/cv_lists'
import { setActiveChannel, setActiveUser } from '../../redux/actions/tabs'
import SidemenuUsers from './SidemenuUsers'
import SidemenuAssignedUsers from './SidemenuAssignedUsers'
import SidemenuUsersSearch from './SidemenuUsersSearch'
import poolLists from '../../redux/poolLists/actions'
import { openOutbound } from '../../redux/outbound/actions'
import SidemenuPoolFolders from './SidemenuPoolFolders'
import { getStaticImage } from 'utils/statics'
import SideMenuHeader from './SideMenuHeader'
import SideMenuInChat from './SideMenuInChat'
import { CHANNELINCHAT } from 'constants/channels'

class SidebarConversation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectTypeOptions: [
        { value: 'all', label: I18n.t('dashboard_all') },
        { value: 'draft', label: I18n.t('dashboard_drafts') },
        { value: 'deferred', label: I18n.t('dashboard_deferred') },
        { value: 'sent', label: I18n.t('dashboard_sent') },
        { value: 'received', label: I18n.t('dashboard_received') },
        { value: 'openedTabs', label: I18n.t('dashboard_openedTabs') }
      ],
      channelsOptions: [],
      orderOptions: [
        { value: 'asc', label: I18n.t('dashboard_order_asc') },
        { value: 'desc', label: I18n.t('dashboard_order_desc') }
      ]
    }

    this.onChangeToSearch = this.onChangeToSearch.bind(this)
    this.getFilters = this.getFilters.bind(this)

    this.getUsersLists = bindActionCreators(fetchLists, props.dispatch)
    this.setActiveUser = bindActionCreators(setActiveUser, props.dispatch)
    this.listsWithUsers = bindActionCreators(poolLists.listsWithUsers, props.dispatch)
    this.openOutbound = bindActionCreators(openOutbound, props.dispatch)
    this.setActiveChannel = bindActionCreators(setActiveChannel, props.dispatch)
  }

  componentDidMount() {
    this.getUsersLists()
    this.listsWithUsers()
    this.getFilters()
  }

  getFilters() {
    apiPools.getFilters()
      .then(({ data }) => {
        const channelsOptions = []

        data.channels.map(channel => channelsOptions.push({
          value: channel,
          label: I18n.t(`channels_${channel}`)
        }))

        this.setState({ channelsOptions })
      })
  }

  onChangeToSearch() {
    this.setActiveUser('')
    this.setActiveChannel('')
  }

  renderBody(activeTab, powerUser, modules) {
    switch (activeTab) {
      case 'lists':
        return <SidemenuPoolFolders selectTypeOptions={this.state.selectTypeOptions} channelsOptions={this.state.channelsOptions} />
      case 'users':
        if (powerUser?.onlyAssignedConversations) return null
        return <SidemenuUsers selectTypeOptions={this.state.selectTypeOptions} channelsOptions={this.state.channelsOptions} />
      case 'assignations':
        return <SidemenuAssignedUsers selectTypeOptions={this.state.selectTypeOptions} channelsOptions={this.state.channelsOptions} />
      case 'inchat':
        if (!modules.inchat.isActive) return null
        return <SideMenuInChat />
      case 'search':
      default:
        return <SidemenuUsersSearch />
    }
  }

  countUsersInLists(lists = {}) {
    let usersInLists = 0

    for (const list in lists) {
      usersInLists += lists[list].length
    }

    return usersInLists ? (
      <Badge color='danger' pill>
        {usersInLists}
      </Badge>
    ) : null
  }

  render() {
    const { match: { params }, cv_lists, powerUser, modules } = this.props
    const activeTab = params.sidemenu

    return (
      <div className='conversation-menu'>
        <SideMenuHeader
          countUsersInLists={this.countUsersInLists}
          cv_lists={cv_lists}
          isListsAvailable={this.props.isListsAvailable}
          listsWithUsers={this.props.listsWithUsers}
          onChangeToSearch={this.onChangeToSearch}
          powerUser={powerUser}
        />
        <div className='conversation-menu__conversations-container'>
          {this.renderBody(activeTab, powerUser, modules)}
        </div>
        {!CHANNELINCHAT.includes(activeTab) ?
          <button
            title={I18n.t('dashboard_new-conversation')}
            className='conversation-menu__outbound-btn'
            onClick={() => this.openOutbound({})}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-plus-white.svg')} alt='Outbound' />
            </figure>
          </button>
          :null}
      </div>
    )
  }
}

export default connect((state) => ({
  cv_lists: state.cv_lists,
  listsWithUsers: state.poolLists.listsWithUsers,
  isListsAvailable: state.poolLists.isListsAvailable,
  powerUser: state.user,
  modules: state.modules
}))(SidebarConversation)
